<template>
  <div>
    <div class="page-container">
      <el-image :src="require('@/assets/images/science/1.jpg')" fit="cover"></el-image>
      <div>
        <div class="sec-title">实验室技术</div>
        <div class="sec-sub-title">
          <div>LABORATORY</div>
          <div>TECHNOLOGY</div>
        </div>
        <div class="gap"></div>
        <div class="sec-sub-title">实验科技严格品控</div>
        <div class="des">Repêchage®拥有专属的独立实验室，并与科研机构和大学合作，为产品研发提供了强大的技术支持，自有工厂具备GMP与ISO认证,采用来自世界各地最优质原料独立完成全部生产环节。</div>
      </div>
      <div class="team-area">
        <div class="sec-title">研发团队</div>
        <div class="sec-sub-title">
          <div>SCIENTIFIC</div>
          <div>RESEARCH TEAM</div>
        </div>
        <div class="team">
          <div class="team-member">
            <el-image :src="require('@/assets/images/science/2.png')" fit="cover" class="member-image"></el-image>
            <div class="member-des">
              <div class="member-title">Dr. Charles Yarish</div>
              <div>国际海洋生物学专家</div>
              <div>康涅狄格大学海洋生物科学教授</div>
              <div>国际海藻海洋生物技术实验室创始人</div>
              <div>Repêchage高级产品研发顾问</div>
            </div>
          </div>
          <div class="team-member">
            <el-image :src="require('@/assets/images/science/3.png')" fit="cover" class="member-image"></el-image>
            <div class="member-des">
              <div class="member-title">Dr. Natalya Fazylova</div>
              <div>美国抗衰老医学研究院专家</div>
              <div>美国纽约城市大学副教授</div>
              <div>美国激光美容治疗专家</div>
              <div>Repêchage专业皮肤护理中心顾问专家</div>
            </div>
          </div>
          <div class="team-member">
            <el-image :src="require('@/assets/images/science/4.png')" fit="cover" class="member-image"></el-image>
            <div class="member-des">
              <div class="member-title">Dr.Samuel Shatkin</div>
              <div>美国最佳外科医生</div>
              <div>美国美容协会整形外科和高级皮肤护理中心医学总监</div>
              <div>Repêchage高级产品研发顾问</div>
              <div>Repêchage专业皮肤护理中心合作专家</div>
            </div>
          </div>
        </div>
      </div>
      <div class="lab_item" v-for="(item, index) in article" :key="index">
        <articleSeaweed :article="item" :position="index%2===0?'left':'right'" />
      </div>
    </div>
  </div>
</template>

<script>
import articleSeaweed from '@/components/article/Seaweed.vue'
export default {
  components: {
    articleSeaweed
  },
  data () {
    return {
      article: [
        { id: 1, title: '海藻生物萃取技术', image: require('@/assets/images/science/5.jpg'), des: 'Repêchage®独立实验室以独家技术海洋植物细胞精华为基底,主打核心的实验室成分“海藻生物细胞活性因子”强大修护原力，唤醒肌肤胶原蛋白再生。滴滴臻萃，探究极致美学的产品质感。' },
        { id: 2, title: '作为海水浓缩物的海藻', image: require('@/assets/images/science/a_1.png'), des: '海藻是一种非常强大的海水浓缩物。一升海藻所含的元素浓度相当于一万升海水。海藻没有根、茎或叶，具有平行结构，包括吸盘、柄和叶片。它们能够通过吸收和主动运输从海水中摄取矿物质，并与细菌密切共生，以获取其生长所需的重要维生素。由于这些过程，一些海藻成为维生素、矿物质、微量元素、常量元素、植物激素、氨基酸、蛋白质和脂质的高浓度物质。' },
        { id: 3, title: 'Repêchage®让你与众不同', image: require('@/assets/images/science/a_2.png'), des: '大多数海藻产品制造商都使用烘箱干燥进行加工。利用这种方法生产的产品含有丰富的微量元素，但可能缺乏对热敏感的维生素和氨基酸。这就是 Repêchage 的与众不同之处。干燥后，海藻被包装并送往经过质量体系 ISO 9001：2015 认证的制造工厂。通过独家特有的方法，Repêchage 能够从海藻中提取细胞间液，同时保留维生素、矿物质、微量元素和氨基酸的活性，手工小批量加工成滤液。' },
        { id: 4, title: '海藻在医药领域的应用', image: require('@/assets/images/science/a_3.png'), des: '海藻（海洋微藻）被用于不同的制药行业，尤其是在药类化合物生产。海藻含有大量的硫酸化多糖，除了用于生物领域外，还被用于药妆行业。含有硫酸多糖的海藻在凝血系统、抗病毒活性、抗氧化活性、抗癌活性、免疫调节活性、和抗脂质代谢异常活性方面中具有很大的潜在功能。从海洋生物中提取的各种多糖，如琼脂和藻酸盐，在食品生产和药妆行业中也被用作多种用途。' },
        { id: 5, title: '化妆品用海藻', image: require('@/assets/images/science/a_4.png'), des: '近年来，消费者对含有天然成分的化妆品的需求不断提高。含有天然成分的化妆品具有环保、副作用小以及使用安全的优点。药妆行业持续寻求天然来源的活性化合物。从这个角度来看，海洋环境提供了许多具有潜在生物活性化合物的海洋生物，包括海藻。海藻富含生物活性化合物，可被用作化妆品的功能性成分。' }
      ]
    }
  }
}
</script>

<style scoped>
.page-container{
  max-width: 1200px;
  margin: 50px auto 20px;
}
.team-member{
  display: flex;
  margin-bottom: 30px;
}
.member-image{
  width: 300px;
  height: 320px;
}
.sec-title{
  font-size: 35px;
  font-weight: 600;
  letter-spacing: 0px;
  box-sizing: border-box;
  padding: 20px 0 0px;
  color: #303133;
}
.sec-sub-title{
  font-size: 18px;
  font-weight: 600;
  color: #303133;
  padding-bottom: 10px;
}
.gap{
  background-color: #9FD8D7;
  width: 200px;
  height: 8px;
  box-sizing: border-box;
  margin: 20px 0;
}
.des{
  font-size: 16px;
  color: #303133;
  line-height: 25px;
}
.team-area{
  box-sizing: border-box;
  padding-top: 20px;
}
.team{
  box-sizing: border-box;
  padding: 20px 0;
}
.member-title{
  font-size: 20px;
  font-weight: 600;
  padding-bottom: 20px;
  color: #303133;
}
.member-des{
  font-size: 16px;
  padding-left: 30px;
  line-height: 30px;
  color: #303133;
}
.sec-c{
  padding: 20px 0;
}
.lab_item{
  padding: 50px 0;
  border-top: 1px solid #DCDFE6;
}
</style>
